import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { ProfileMenuComponent } from './profile-menu.component';
import { UnitFormatterModule } from '@app/_shared/pipes/locale-formatter/locale-formatter.module';
import { LocaleConverterModule, NullCheckModule, PrecisionModule } from '@app/_shared/pipes';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { VerifyDialogModule } from '../verify-dialog/verify-dialog.module';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { RouterModule } from '@angular/router';
import { MatDividerModule } from '@angular/material/divider';
import { MatLegacyProgressBarModule as MatProgressBarModule } from '@angular/material/legacy-progress-bar';
import { DisplayPictureModule } from '@app/modules/trading/modules/profile/components/user/display-picture/display-picture.module';
import { MbPlansModule } from '@app/modules/trading/modules/mb-plans/mb-plans.module';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { WalletCardShimmerModule } from './wallet-card-shimmer/wallet-card-shimmer.module';


@NgModule({
  declarations: [ProfileMenuComponent],
  imports: [
    CommonModule,
    MatIconModule,
    UnitFormatterModule,
    LocaleConverterModule,
    PrecisionModule,
    MatDialogModule,
    VerifyDialogModule,
    MatButtonModule,
    RouterModule,
    MatDividerModule,
    MatProgressBarModule,
    DisplayPictureModule,
    MbPlansModule,
    NullCheckModule,
    MatProgressSpinnerModule,
    MatTooltipModule,
    WalletCardShimmerModule
  ], 
  exports: [
    ProfileMenuComponent
  ]
})
export class ProfileMenuModule { }
